import React, { useState, useEffect, useCallback, lazy, Suspense } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import * as actions from './actions';

import Layout from './containers/Layout';
import PrivateRoutes from './utils/PrivateRoutes';
import Login from './Login';
import Home from './containers/Home';
import ErrorPage from './containers/ErrorPage';

//import { URL } from './constants';

import ActiveContext from './context/ActiveContext';

const RegisterAccount = lazy(() => import('./containers/account/RegisterAccount'));
const PersonDataMaintain = lazy(() => import('./containers/PersonDataMaintain'));
const RegisterOrgAccount = lazy(() => import('./containers/account/RegisterOrgAccount'));

const SystemFunction = lazy(() => import('./containers/system/systemFunction/SystemFunction'));
const SystemFunctionCreate = lazy(() => import('./containers/system/systemFunction/SystemFunctionCreate'));
const SystemFunctionUpdate = lazy(() => import('./containers/system/systemFunction/SystemFunctionUpdate'));

const VerifyAccount = lazy(() => import('./containers/system/verifyAccount/VerifyAccount'));
const VerifyAccountUpdate = lazy(() => import('./containers/system/verifyAccount/VerifyAccountUpdate'));

const BulletinBoardAdmQuery = lazy(() => import('./containers/bulletinBoard/BulletinBoardAdmQuery'));
const BulletinBoardQuery = lazy(() => import('./containers/bulletinBoard/BulletinBoardQuery'));
const BulletinBoardCheck = lazy(() => import('./containers/bulletinBoard/BulletinBoardCheck'));
const BulletinBoardModify = lazy(() => import('./containers/bulletinBoard/BulletinBoardModify'))
const BulletinBoardCreate = lazy(() => import('./containers/bulletinBoard/BulletinBoardCreate'))

const CommonProblemAsk = lazy(() => import('./containers/commonProblem/CommonProblemAsk'));
const CommonProblemCheck = lazy(() => import('./containers/commonProblem/CommonProblemCheck'));
const CommonProblemQuery = lazy(() => import('./containers/commonProblem/CommonProblemQuery'));
const CommonProblemAdmQuery = lazy(() => import('./containers/commonProblem/CommonProblemAdmQuery'));
const CommonProblemCreate = lazy(() => import('./containers/commonProblem/CommonProblemCreate'));
const CommonProblemModify = lazy(() => import('./containers/commonProblem/CommonProblemModify'));

const AccountMaintain = lazy(() => import('./containers/system/accountMaintain/accountMaintain'));
const AccountMaintainUpdate = lazy(() => import('./containers/system/accountMaintain/accountMaintainUpdate'));
const AccountMaintainCreate = lazy(() => import('./containers/system/accountMaintain/accountMaintainCreate'));

const EmailNotice = lazy(() => import('./containers/system/emailNotice/EmailNotice'));
const EmailNoticeUpdate = lazy(() => import('./containers/system/emailNotice/EmailNoticeUpdate'));
const EmailNoticeLogQuery = lazy(() => import('./containers/system/emailNotice/EmailNoticeLogQuery'));

const SystemParameter = lazy(() => import('./containers/system/systemParameter/SystemParameter'));
const SystemParameterCreate = lazy(() => import('./containers/system/systemParameter/SystemParameterCreate'));
const SystemParameterCreateDetail = lazy(() => import('./containers/system/systemParameter/SystemParameterCreateDetail'));
const SystemParameterUpdate = lazy(() => import('./containers/system/systemParameter/SystemParameterUpdate'));
const SystemParameterUpdateDetail = lazy(() => import('./containers/system/systemParameter/SystemParameterUpdateDetail'));

const GroupQuery = lazy(() => import('./containers/system/group/GroupQuery'));
const GroupCreate = lazy(() => import('./containers/system/group/GroupCreate'));
const GroupUpdate = lazy(() => import('./containers/system/group/GroupUpdate'));

const OperationManual = lazy(() => import('./containers/operationManual/OperationManualQuery'));
const OperationManualAdmQuery= lazy(() => import('./containers/operationManual/OperationManualAdmQuery'));
const OperationManualCreate = lazy(() => import('./containers/operationManual/OperationManualCreate'));
const OperationManualModify = lazy(() => import('./containers/operationManual/OperationManualModify'));

const ChangePassword = lazy(() => import('./containers/ChangePassword'));

const BidCaseStatusQuery = lazy(() => import('./containers/bidCaseStatus/BidCaseStatusQuery'));

const Certificate = lazy(() => import('./containers/application/certificate/Certificate'));
const CertificateView = lazy(() => import('./containers/application/certificate/CertificateView'));
const CertificateViewForNotice = lazy(() => import('./containers/application/certificate/CertificateViewForNotice'));
const CertificateUpdate = lazy(() => import('./containers/application/certificate/CertificateUpdate'));
const CertificateUpdateSpecies = lazy(() => import('./containers/application/certificate/CertificateUpdateSpecies'));

const CertificateApplyProcessQuery = lazy(() => import('./containers/application/certificate/CertificateApplyProcessQuery'));
const CertificateApplyProcessView = lazy(() => import('./containers/application/certificate/CertificateApplyProcessView'));

const ChooseDocument = lazy(() => import('./containers/application/applyDocument/ChooseDocument'));
const ChooseForm = lazy(() => import('./containers/application/applyDocument/ChooseForm'));
const ApplyDocumentCreate = lazy(() => import('./containers/application/applyDocument/ApplyDocumentCreate'));
const ApplyItem = lazy(() => import('./containers/application/applyDocument/ApplyItem'));
const CreateItem = lazy(() => import('./containers/application/applyDocument/CreateItem'));
const ApplyDocumentAttach = lazy(() => import('./containers/application/applyDocument/ApplyDocumentAttach'));
const ApplyDocumentView = lazy(() => import('./containers/application/applyDocument/ApplyDocumentView'));
const ApplySuccess = lazy(() => import('./containers/application/applyDocument/ApplySuccess'));
const NewSpecies = lazy(() => import('./containers/application/applyDocument/NewSpecies'));
const FIForm1 = lazy(() => import('./containers/application/applyDocument/firstImport/Form1'));
const FIForm2 = lazy(() => import('./containers/application/applyDocument/firstImport/Form2'));
const FIForm2ForView = lazy(() => import('./containers/application/applyDocument/firstImport/Form2ForView'));

const ApplySpeciesQuery = lazy(() => import('./containers/application/applySpecies/ApplySpeciesQuery'));
const ApplySpeciesCreate = lazy(() => import('./containers/application/applySpecies/ApplySpeciesCreate'));
const ApplySpeciesModify = lazy(() => import('./containers/application/applySpecies/ApplySpeciesModify'));

const VerifySpeciesQuery = lazy(() => import('./containers/verifySpecies/VerifySpeciesQuery'));
const VerifySpeciesOperation = lazy(() => import('./containers/verifySpecies/VerifySpeciesOperation'));

const FiSpeciesBatchQuery = lazy(() => import('./containers/fiSpecies/FiSpeciesBatchQuery'));
const FiSpeciesBatchCreate = lazy(() => import('./containers/fiSpecies/FiSpeciesBatchCreate'));
const FiSpeciesBatchModify = lazy(() => import('./containers/fiSpecies/FiSpeciesBatchModify'));
const FiSpeciesBatchView = lazy(() => import('./containers/fiSpecies/FiSpeciesBatchView'));
const FiSpeciesExpertQuery = lazy(() => import('./containers/fiSpecies/FiSpeciesExpertQuery'));
const FiSpeciesExpertReview = lazy(() => import('./containers/fiSpecies/FiSpeciesExpertReview'));


const BidCaseReviewQuery = lazy(() => import('./containers/bidCaseReview/BidCaseReviewQuery'));
const BidCaseReviewOperation = lazy(() => import('./containers/bidCaseReview/BidCaseReviewOperation'));
const BidCaseReviewSpecies = lazy(() => import('./containers/bidCaseReview/BidCaseReviewSpecies'));
const BidCaseReviewHistory = lazy(() => import('./containers/bidCaseReview/BidCaseReviewHistory'));
const BidCaseReviewNewVerify = lazy(() => import('./containers/bidCaseReview/BidCaseReviewNewVerify'));
const BidCaseReviewFinal = lazy(() => import('./containers/bidCaseReview/BidCaseReviewFinal'));

const FiCaseReviewQuery = lazy(() => import('./containers/fiCaseReview/FiCaseReviewQuery'));
const FiCaseReviewOperation = lazy(() => import('./containers/fiCaseReview/FiCaseReviewOperation'));
const FiCaseReviewSpecies = lazy(() => import('./containers/fiCaseReview/FiCaseReviewSpecies'));
const FiCaseReviewHistory = lazy(() => import('./containers/fiCaseReview/FiCaseReviewHistory'));
const FiCaseReviewNewVerify = lazy(() => import('./containers/fiCaseReview/FiCaseReviewNewVerify'));
const FiCaseReviewFinal = lazy(() => import('./containers/fiCaseReview/FiCaseReviewFinal'));

const BidCaseSettingQuery = lazy(() => import('./containers/bidCaseSetting/BidCaseSettingQuery'));
const BidCaseSettingCreate = lazy(() => import('./containers/bidCaseSetting/BidCaseSettingCreate'));
const BidCaseSettingModify = lazy(() => import('./containers/bidCaseSetting/BidCaseSettingModify'));

const ReviewStage = lazy(() => import('./containers/system/reviewStage/ReviewStage'));
const ReviewStageEdit = lazy(() => import('./containers/system/reviewStage/ReviewStageEdit'));
const ReviewStageSetting = lazy(() => import('./containers/system/reviewStage/ReviewStageSetting'));

const SpeciesMaintainQuery = lazy(() => import('./containers/system/speciesMaintain/SpeciesMaintainQuery'));
const SpeciesMaintainCreate = lazy(() => import('./containers/system/speciesMaintain/SpeciesMaintainCreate'));
const SpeciesMaintainModify = lazy(() => import('./containers/system/speciesMaintain/SpeciesMaintainModify'));
const SpeciesMaintainImport = lazy(() => import('./containers/system/speciesMaintain/SpeciesMaintainImport'));

const TaibnetSpeciesQuery = lazy(() => import('./containers/system/taibnetSpeciesMaintain/TaibnetSpeciesQuery'));
const TaibnetSpeciesCreate = lazy(() => import('./containers/system/taibnetSpeciesMaintain/TaibnetSpeciesCreate'));
const TaibnetSpeciesModify = lazy(() => import('./containers/system/taibnetSpeciesMaintain/TaibnetSpeciesModify'));
const TaibnetSpeciesImport = lazy(() => import('./containers/system/taibnetSpeciesMaintain/TaibnetSpeciesImport'));

const CitesSpeciesQuery = lazy(() => import('./containers/system/citesSpeciesMaintain/CitesSpeciesQuery'));
const CitesSpeciesCreate = lazy(() => import('./containers/system/citesSpeciesMaintain/CitesSpeciesCreate'));
const CitesSpeciesModify = lazy(() => import('./containers/system/citesSpeciesMaintain/CitesSpeciesModify'));
const CitesSpeciesImport = lazy(() => import('./containers/system/citesSpeciesMaintain/CitesSpeciesImport'));

const ProtectedSpeciesQuery = lazy(() => import('./containers/system/protectedSpecies/ProtectedSpeciesQuery'));
const ProtectedSpeciesCreate = lazy(() => import('./containers/system/protectedSpecies/ProtectedSpeciesCreate'));
const ProtectedSpeciesModify = lazy(() => import('./containers/system/protectedSpecies/ProtectedSpeciesModify'));
const ProtectedSpeciesImport = lazy(() => import('./containers/system/protectedSpecies/ProtectedSpeciesImport'));

const CertDocBalQuery = lazy(() => import('./containers/reports/CertDocBalQuery'));
const AppCaseExport = lazy(() => import('./containers/reports/AppCaseExport'));
const AppCaseSpeciesExport = lazy(() => import('./containers/reports/AppCaseSpeciesExport'));

const HistoryCensorQuery = lazy(() => import('./containers/system/historyCensor/HistoryCensorQuery.js'));
const HistoryCensorCreate = lazy(() => import('./containers/system/historyCensor/HistoryCensorCreate.js'));
const HistoryCensorModify = lazy(() => import('./containers/system/historyCensor/HistoryCensorModify.js'));

const CompareOperation = lazy(() => import('./containers/compare/CompareOperation'));
const CompareQuery = lazy(() => import('./containers/compare/CompareQuery'));
const CompareSettingParm = lazy(() => import('./containers/compare/CompareSettingParm'));
const CompareSettingParmUpdate = lazy(() => import('./containers/compare/CompareSettingParmUpdate'));
const CompareQueryClearance = lazy(() => import('./containers/compare/CompareQueryClearance'));
const CompareQueryException = lazy(() => import('./containers/compare/CompareQueryException'));
const CompareEditException = lazy(() => import('./containers/compare/CompareEditException'));
const CompareQueryOriginal = lazy(() => import('./containers/compare/CompareQueryOriginal'));
const CompareView = lazy(() => import('./containers/compare/CompareView'));
const CompareManual = lazy(() => import('./containers/compare/CompareManual'));
const CompareSecond = lazy(() => import('./containers/compare/CompareSecond'));


const PermissionMaintain = lazy(() => import('./containers/system/permissionMaintain/permissionMaintain'));
const PermissionMaintainUpdate = lazy(() => import('./containers/system/permissionMaintain/permissionMaintainUpdate'));
const PermissionMaintainSet = lazy(() => import('./containers/system/permissionMaintain/permissionMaintainSet'));

const TriggerQuery = lazy(() => import('./containers/system/trigger/TriggerQuery'));
const TriggerSetting = lazy(() => import('./containers/system/trigger/TriggerSetting'));
const TriggerLogQuery = lazy(() => import('./containers/system/trigger/TriggerLogQuery'));

const ErrorLogQuery = lazy(() => import('./containers/system/errorLog/ErrorLogQuery'));
const ErrorLogView = lazy(() => import('./containers/system/errorLog/ErrorLogView'));

const LoginLogQuery = lazy(() => import('./containers/system/loginLog/LoginLogQuery'));
const FunctionSetAccessLog = lazy(() => import('./containers/system/functionAccess/FunctionSetAccessLog'));
const AccessLogQuery = lazy(() => import('./containers/system/functionAccess/AccessLogQuery'));
const ChangeLogQuery = lazy(() => import('./containers/system/changeLog/ChangeLogQuery'));

const CCCCodeQuery = lazy(() => import('./containers/CCCCode/CCCCodeQuery'));
const CCCCodeCreate = lazy(() => import('./containers/CCCCode/CCCCodeCreate'));
const CCCCodeUpdate = lazy(() => import('./containers/CCCCode/CCCCodeUpdate'));
const RegulationQuery = lazy(() => import('./containers/CCCCode/RegulationQuery'));
const RegulationCreate = lazy(() => import('./containers/CCCCode/RegulationCreate'));
const OnlineUserQuery = lazy(() => import('./containers/system/onlineUser/OnlineUserQuery'));

const DirectionQuery = lazy(() => import('./containers/system/direction/DirectionQuery'));
const DirectionCreate = lazy(() => import('./containers/system/direction/DirectionCreate'));
const DirectionEdit = lazy(() => import('./containers/system/direction/DirectionEdit'));

const SyncSpeciesData = lazy(() => import('./containers/sync/SyncSpeciesData'));

const UpdateSameNameSpecies = lazy(() => import('./containers/system/sameNameSpecies/UpdateSameNameSpecies'));

//TM 相關功能
const TM0100List = lazy(() => import('./containers/bill/report/List'));
const TM0200List = lazy(() => import('./containers/bill/config/List'));
const TM0200Add  = lazy(() => import('./containers/bill/config/Add'));
const TM0200Edit = lazy(() => import('./containers/bill/config/Edit'));
const PM2000List = lazy(() => import('./containers/bill/record/List'));
const PM2000View = lazy(() => import('./containers/bill/record/View'));

let purposeList = Object.entries({ '': '' });
let appStatusList = Object.entries({ '': '' });
let docTypeList = Object.entries({ '': '' });
let appTypeList = Object.entries({ '': '' });
let appResultList = Object.entries({ '': '' });
let stageStatusList = Object.entries({ '': '' });
let orgList = Object.entries({ '': '' });
let speciesTypeList = Object.entries({ '': '' });
let ieTypeList = Object.entries({ '': '' });
let vanIdList = Object.entries({ '': '' });
let compareStateList = Object.entries({ '': '' });

const App = props => {
  const dispatch = useDispatch();
  const loginSuccess = useCallback((token, user) => dispatch(actions.loginSuccess(token, user)), [dispatch]);
  const logout = useCallback((token) => dispatch(actions.logout()), [dispatch]);

  const [active, setActive] = useState(false);

  /*const init = useCallback(async () => {
	  // init code list
    purposeList = await fetch(`${URL}/system/code/findCode/PURPOSE`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      method: 'GET'
    }).then(res => res.json()).then(purpose => Object.entries(purpose).map(([k, v]) => {
      return v;
    }));
    
    appStatusList = await fetch(`${URL}/system/code/findCode/APPSTATUS`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        method: 'GET'
    }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
        return v;
    }));

    docTypeList = await fetch(`${URL}/system/appDoc/findDocType`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        method: 'GET'
    }).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
        return v;
    }));
    
    appTypeList = await fetch(`${URL}/system/code/findCode/APPTYPE`, {
      credentials: 'include',
	    headers: { 'Content-Type': 'application/json' },
	    method: 'GET'
	}).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
    	return v;
    }));
    
    appResultList = await fetch(`${URL}/system/code/findCode/APPRESULT`, {
      credentials: 'include',
	    headers: { 'Content-Type': 'application/json' },
	    method: 'GET'
	}).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
    	return v;
    }));
    
    stageStatusList = await fetch(`${URL}/system/code/findCode/STAGESTATUS`, {
      credentials: 'include',
	    headers: { 'Content-Type': 'application/json' },
	    method: 'GET'
	}).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
    	return v;
    }));
    
    orgList = await fetch(`${URL}/system/code/findCode/DIRECTION`, {
      credentials: 'include',
	    headers: { 'Content-Type': 'application/json' },
	    method: 'GET'
	}).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
    	return v;
    }));
    
    speciesTypeList = await fetch(`${URL}/system/code/findCode/SPECIES_TYPE`, {
      credentials: 'include',
	    headers: { 'Content-Type': 'application/json' },
	    method: 'GET'
	}).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
    	return v;
    }));
    
    ieTypeList = await fetch(`${URL}/system/code/findCode/IE`, {
      credentials: 'include',
	    headers: { 'Content-Type': 'application/json' },
	    method: 'GET'
	}).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
    	return v;
    }));
    
    vanIdList = await fetch(`${URL}/system/code/findCode/VI`, {
      credentials: 'include',
	    headers: { 'Content-Type': 'application/json' },
	    method: 'GET'
	}).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
    	return v;
    }));
    
    compareStateList = await fetch(`${URL}/system/code/findCode/CR`, {
      credentials: 'include',
	    headers: { 'Content-Type': 'application/json' },
	    method: 'GET'
	}).then(res => res.json()).then(status => Object.entries(status).map(([k, v]) => {
    	return v;
    }));
    
  }, []);*/


  useEffect(() => {
    //init();
    // In case a user refreshes the page and lose the auth state. 
    const token = sessionStorage.getItem('token');
    const user = sessionStorage.getItem('user');
    if (token && user) {
      loginSuccess(token, user);
    } else {
      logout();
    }
  }, [loginSuccess, logout]);

  return (
    <ActiveContext.Provider value={[active, setActive]}>
      <div className="App">
        <Suspense fallback={<div id="mask" className="mask"><div className="processing"><h1>處理中，請稍後...</h1></div></div>}>
          <Switch>
            <Route path="/login" exact component={Login} />
            
            {/* <Route path="/error" exact component={ErrorPage} /> 
            <Redirect to="/error"/> */}

            <Route path="/RegisterAccount" exact component={RegisterAccount} />
            <Route path="/RegisterOrgAccount" exact component={RegisterOrgAccount} />

            <PrivateRoutes>
              <Layout>
                <Route path="/" exact component={Home} />

                <Route path="/System/GroupQuery" exact component={GroupQuery} />
                <Route path="/System/group/create" exact component={GroupCreate} />
                <Route path="/System/group/update" exact component={GroupUpdate} />

                <Route path="/System/SystemFunction" exact component={SystemFunction} />
                <Route path="/System/SystemFunction/Create" exact component={SystemFunctionCreate} />
                <Route path="/System/SystemFunction/Update" exact component={SystemFunctionUpdate} />

                <Route path="/System/VerifyAccount" exact component={VerifyAccount} />
                <Route path="/System/VerifyAccount/Update" exact component={VerifyAccountUpdate} />

                <Route path="/System/AccountMaintain" exact component={AccountMaintain} />
                <Route path="/System/AccountMaintain/Update" exact component={AccountMaintainUpdate} />
                <Route path="/System/AccountMaintain/Create" exact component={AccountMaintainCreate} />

                <Route path="/System/SystemParameter" exact component={SystemParameter} />
                <Route path="/System/SystemParameter/Create" exact component={SystemParameterCreate} />
                <Route path="/System/SystemParameter/CreateDetail" exact component={SystemParameterCreateDetail} />
                <Route path="/System/SystemParameterUpdate" exact component={SystemParameterUpdate} />
                <Route path="/System/SystemParameter/UpdateDetail" exact component={SystemParameterUpdateDetail} />

                <Route path="/System/EmailNotice" exact component={EmailNotice} />
                <Route path="/System/EmailNotice/Update" exact component={EmailNoticeUpdate} />
                <Route path="/System/EmailNoticeLogQuery" exact component={EmailNoticeLogQuery} />

                <Route path="/PersonDataMaintain" exact component={PersonDataMaintain} />
                <Route path="/PersonDataMaintain/ChangePassword" exact component={ChangePassword} />

                <Route path="/BulletinBoardAdmQuery" exact component={BulletinBoardAdmQuery} />
                <Route path="/BulletinBoardQuery" exact component={BulletinBoardQuery} />
                <Route path="/BulletinBoardCheck" exact component={BulletinBoardCheck} />
                <Route path="/BulletinBoardModify" exact component={BulletinBoardModify} />
                <Route path="/BulletinBoardCreate" exact component={BulletinBoardCreate} />

                <Route path="/CommonProblemAsk" exact component={CommonProblemAsk} />
                <Route path="/CommonProblemCheck" exact component={CommonProblemCheck} />
                <Route path="/CommonProblemQuery" exact component={CommonProblemQuery} />
                <Route path="/CommonProblemAdmQuery" exact component={CommonProblemAdmQuery} />
                <Route path="/CommonProblemCreate" exact component={CommonProblemCreate} />
                <Route path="/CommonProblemModify" exact component={CommonProblemModify} />

                <Route path="/OperationManual" exact component={OperationManual} />
                <Route path="/OperationManualAdmQuery" exact component={OperationManualAdmQuery} />
                <Route path="/OperationManualCreate" exact component={OperationManualCreate} />
                <Route path="/OperationManualModify" exact component={OperationManualModify} />

                <Route path='/Application/Certificate' exact component={Certificate} />
                <Route path='/Application/CertificateView' exact component={CertificateView} />
                <Route path='/Application/CertificateViewForNotice' exact component={CertificateViewForNotice} />
                <Route path='/Application/CertificateUpdate' exact component={CertificateUpdate} />
                <Route path='/Application/CertificateUpdateSpecies' exact component={CertificateUpdateSpecies} />

                <Route path='/Application/CertificateApplyProcessQuery' exact component={CertificateApplyProcessQuery} />
                <Route path='/Application/CertificateApplyProcessView' exact component={CertificateApplyProcessView} />

                <Route path='/application/applyDocument/ChooseDocument' exact component={ChooseDocument} />
                <Route path='/application/applyDocument/ChooseForm' exact component={ChooseForm} />
                <Route path='/application/applyDocument/ApplyDocumentCreate' exact component={ApplyDocumentCreate} />
                <Route path='/application/applyDocument-ApplyItem' exact component={ApplyItem} />
                <Route path='/application/applyDocument/CreateItem' exact component={CreateItem} />
                <Route path='/application/applyDocument/ApplyDocumentAttach' exact component={ApplyDocumentAttach} />
                <Route path='/application/applyDocument/ApplyDocumentView' exact component={ApplyDocumentView} />
                <Route path='/application/applyDocument-ApplyDocumentView' exact component={ApplyDocumentView} />
                <Route path='/application/applyDocument/ApplySuccess' exact component={ApplySuccess} />
                <Route path='/application/applyDocument/NewSpecies' exact component={NewSpecies} />
                <Route path='/application/applyDocument/firstImport/Form1' exact component={FIForm1} />
                <Route path='/application/applyDocument/firstImport/Form2' exact component={FIForm2} />
                <Route path='/application/applyDocument/firstImport/Form2ForView' exact component={FIForm2ForView} />

                <Route path='/Application/applySpecies/ApplySpeciesQuery' exact component={ApplySpeciesQuery} />
                <Route path='/Application/applySpecies/ApplySpeciesCreate' exact component={ApplySpeciesCreate} />
                <Route path='/Application/applySpecies/ApplySpeciesModify' exact component={ApplySpeciesModify} />

                <Route path='/Application/verifySpecies/VerifySpeciesQuery' exact component={VerifySpeciesQuery} />
                <Route path='/Application/verifySpecies/VerifySpeciesOperation' exact component={VerifySpeciesOperation} />

                <Route path='/Application/fiSpecies/FiSpeciesBatchQuery' exact component={FiSpeciesBatchQuery} />
                <Route path='/Application/fiSpecies/FiSpeciesBatchCreate' exact component={FiSpeciesBatchCreate} />
                <Route path='/Application/fiSpecies/FiSpeciesBatchModify' exact component={FiSpeciesBatchModify} />
                <Route path='/Application/fiSpecies/FiSpeciesBatchView' exact component={FiSpeciesBatchView} />
                <Route path='/Application/fiSpecies/FiSpeciesExpertQuery' exact component={FiSpeciesExpertQuery} />
                <Route path='/Application/fiSpecies/FiSpeciesExpertReview' exact component={FiSpeciesExpertReview} />

                <Route path='/application/BidCaseReviewQuery' exact component={BidCaseReviewQuery} />
                <Route path='/application/BidCaseReviewOperation' exact component={BidCaseReviewOperation} />
                <Route path='/application/BidCaseReviewSpecies' exact component={BidCaseReviewSpecies} />
                <Route path='/application/BidCaseReviewHistory' exact component={BidCaseReviewHistory} />
                <Route path='/application/BidCaseReviewNewVerify' exact component={BidCaseReviewNewVerify} />
                <Route path='/application/BidCaseReviewFinal' exact component={BidCaseReviewFinal} />

                <Route path='/application/FiCaseReviewQuery' exact component={FiCaseReviewQuery} />
                <Route path='/application/FiCaseReviewOperation' exact component={FiCaseReviewOperation} />
                <Route path='/application/FiCaseReviewSpecies' exact component={FiCaseReviewSpecies} />
                <Route path='/application/FiCaseReviewHistory' exact component={FiCaseReviewHistory} />
                <Route path='/application/FiCaseReviewNewVerify' exact component={FiCaseReviewNewVerify} />
                <Route path='/application/FiCaseReviewFinal' exact component={FiCaseReviewFinal} />

                <Route path='/application/BidCaseStatusQuery' exact component={BidCaseStatusQuery} />

                <Route path='/System/ReviewStage-ReviewStage' exact component={ReviewStage} />
                <Route path='/System/ReviewStage/ReviewStageEdit' exact component={ReviewStageEdit} />
                <Route path='/System/ReviewStage-ReviewStageSetting' exact component={ReviewStageSetting} />

                <Route path='/application/BidCaseSettingQuery' exact component={BidCaseSettingQuery} />
                <Route path='/application/BidCaseSettingCreate' exact component={BidCaseSettingCreate} />
                <Route path='/application/BidCaseSettingModify' exact component={BidCaseSettingModify} />

                <Route path='/System/SpeciesMaintainQuery' exact component={SpeciesMaintainQuery} />
                <Route path='/System/SpeciesMaintainCreate' exact component={SpeciesMaintainCreate} />
                <Route path='/System/SpeciesMaintainModify' exact component={SpeciesMaintainModify} />
                <Route path='/System/SpeciesMaintainImport' exact component={SpeciesMaintainImport} />

                <Route path='/System/TaibnetSpeciesQuery' exact component={TaibnetSpeciesQuery} />
                <Route path='/System/TaibnetSpeciesCreate' exact component={TaibnetSpeciesCreate} />
                <Route path='/System/TaibnetSpeciesModify' exact component={TaibnetSpeciesModify} />
                <Route path='/System/TaibnetSpeciesImport' exact component={TaibnetSpeciesImport} />

                <Route path='/System/CitesSpeciesQuery' exact component={CitesSpeciesQuery} />
                <Route path='/System/CitesSpeciesCreate' exact component={CitesSpeciesCreate} />
                <Route path='/System/CitesSpeciesModify' exact component={CitesSpeciesModify} />
                <Route path='/System/CitesSpeciesImport' exact component={CitesSpeciesImport} />

                <Route path='/System/ProtectedSpeciesQuery' exact component={ProtectedSpeciesQuery} />
                <Route path='/System/ProtectedSpeciesCreate' exact component={ProtectedSpeciesCreate} />
                <Route path='/System/ProtectedSpeciesModify' exact component={ProtectedSpeciesModify} />
                <Route path='/System/ProtectedSpeciesImport' exact component={ProtectedSpeciesImport} />

                <Route path='/reports/CertDocQuery' exact component={CertDocBalQuery} />
                <Route path='/reports/AppCaseExport' exact component={AppCaseExport} />
                <Route path='/reports/AppCaseSpeciesExport' exact component={AppCaseSpeciesExport} />

                <Route path='/System/HistoryCensorQuery' exact component={HistoryCensorQuery} />
                <Route path='/System/HistoryCensorCreate' exact component={HistoryCensorCreate} />
                <Route path='/System/HistoryCensorModify' exact component={HistoryCensorModify} />
    
                <Route path='/Compare/CompareOperation' exact component={CompareOperation} />
                <Route path='/Compare/CompareQuery' exact component={CompareQuery} />
                <Route path='/Compare/CompareSettingParm' exact component={CompareSettingParm} />
                <Route path='/Compare/CompareSettingParmUpdate' exact component={CompareSettingParmUpdate} />
                <Route path='/Compare/CompareQueryClearance' exact component={CompareQueryClearance} />
                <Route path='/Compare/CompareQueryException' exact component={CompareQueryException} />
                <Route path='/Compare/CompareEditException' exact component={CompareEditException} />
                <Route path='/Compare/CompareQueryOriginal' exact component={CompareQueryOriginal} />
                <Route path='/Compare/CompareView' exact component={CompareView} />
                <Route path='/Compare/CompareManual' exact component={CompareManual} />
                <Route path='/Compare/CompareSecond' exact component={CompareSecond} />


                <Route path="/System/PermissionMaintain" exact component={PermissionMaintain} />
                <Route path="/System/PermissionMaintain/Update" exact component={PermissionMaintainUpdate} />
                <Route path="/System/PermissionMaintain/Set" exact component={PermissionMaintainSet} />

                <Route path='/System/TriggerQuery' exact component={TriggerQuery} />
                <Route path='/System/TriggerSetting' exact component={TriggerSetting} />
                <Route path='/System/TriggerLogQuery' exact component={TriggerLogQuery} />

                <Route path='/System/ErrorLogQuery' exact component={ErrorLogQuery} />
                <Route path='/System/ErrorLogView' exact component={ErrorLogView} />

                <Route path='/System/LoginLogQuery' exact component={LoginLogQuery} />
                <Route path='/System/FunctionSetAccessLog' exact component={FunctionSetAccessLog} />
                <Route path='/System/AccessLogQuery' exact component={AccessLogQuery} />
                <Route path='/System/ChangeLogQuery' exact component={ChangeLogQuery} />    
                <Route path='/System/OnlineUserQuery' exact component={OnlineUserQuery} />

                <Route path='/System/CCCCodeQuery' exact component={CCCCodeQuery} />
                <Route path='/System/CCCCodeCreate' exact component={CCCCodeCreate} />
                <Route path='/System/CCCCodeUpdate' exact component={CCCCodeUpdate} />
                <Route path='/System/RegulationQuery' exact component={RegulationQuery} />
                <Route path='/System/RegulationCreate' exact component={RegulationCreate} />
                
                <Route path='/System/DirectionQuery' exact component={DirectionQuery} />
                <Route path='/System/DirectionCreate' exact component={DirectionCreate} />
                <Route path='/System/DirectionEdit' exact component={DirectionEdit} />

                <Route path='/System/GroupQuery2' exact component={SyncSpeciesData} />

                <Route path='/System/UpdateSameNameSpecies' exact component={UpdateSameNameSpecies} />

                <Route path='/Bill/Report/List' exact component={TM0100List} />
                <Route path='/Bill/Config/List' exact component={TM0200List} />
                <Route path='/Bill/Config/Add'  exact component={TM0200Add}  />
                <Route path="/Bill/Config/Edit" exact component={TM0200Edit} />
                <Route path="/Bill/Record/List" exact component={PM2000List} />
                <Route path="/Bill/Record/View" exact component={PM2000View} />

                <Redirect to="/" />
              </Layout>
            </PrivateRoutes>
          </Switch>
        </Suspense>
      </div>
    </ActiveContext.Provider>
  );
}
export { purposeList, appStatusList, docTypeList, appTypeList, appResultList, stageStatusList, orgList, speciesTypeList, ieTypeList, vanIdList, compareStateList };
export default withRouter(App);